import axios from '../axios';

export default {
  connectEvoApi () {
    return new Promise((resolve, reject) => {
      axios.post('connect-evo-api')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  createBillingAccount (phone) {
    return new Promise((resolve, reject) => {
      axios.post('create-billing-account', { phone })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  billingInfo (apartmentId) {
    return new Promise((resolve, reject) => {
      axios.get(`apartment-sip-settings/${apartmentId}/billing-info`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getSipSettings ({ login, reason }) {
    return new Promise((resolve, reject) => {
      axios.get('apartment-sip-settings/password', {
        params: {
          login,
          reason,
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  editPaid (apartmentSipSettingsId, paid) {
    return new Promise((resolve, reject) => {
      axios.put(`apartment-sip-settings/${apartmentSipSettingsId}/paid`, {
        paid: paid,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  apartmentPayment (doorphoneId, paid, apartment) {
    return new Promise((resolve, reject) => {
      axios.put(`doorphone/${doorphoneId}/apartment-payment`, {
        paid: paid,
        apartment: apartment,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
